<script setup lang="ts">
import {computed} from "vue";
import SubscriptionPlanService from "@/subscription-plan/services/SubscriptionPlanService";
import {storeToRefs} from "pinia";
import {useSubscriptionPlanStore} from "@/stores/subscription-plan.store";
import Icon from "@/core/components/icon/Icon.vue";

const {globalPlan} = storeToRefs(useSubscriptionPlanStore());

const hasActiveSubscription = computed(() => {
    if (!globalPlan.value) {
        return false;
    }

    return SubscriptionPlanService.hasActiveSubscription(globalPlan.value);
});
</script>

<template>
  <router-link
    v-if="globalPlan && !hasActiveSubscription"
    :to="{name: 'subscription-plans'}"
    class="rounded-md bg-secondary text-primary px-2 py-1 flex items-center gap-2"
  >
    <icon name="mdi-crown" color="primary" />
    <span class="text-sm leading-tight">50 SMS/mois inclut dans premium</span>
  </router-link>
</template>

<style scoped>

</style>
